import React, { useEffect, useState } from "react";
import useRouter from "@stadium/hooks/lib/use-custom-route";
import isEmpty from "lodash/isEmpty";
import remove from "lodash/remove";

import { usePageNameContext } from "@stadium/shared/page-name-provider";

import useFetchMarketingCategories from "@hooks/use-fetch-marketing-categories";

import TemplateViews from "@components/all-templates/views";
import CategoriesSection from "@components/all-templates/categories";
import AllTemplatesHeader from "@components/all-templates/header";
import SearchInput from "@sharedComponents/search-input";
import InstantSearchWrapper from "@stadium/shared/src/components/instant-search";
import AccountShops from "@components/all-templates/views/account-shops-view";
import RecommendedTemplate from "@components/all-templates/views/recommended-template-view";

import { getCapitalisedSlug, getCategoryTitle } from "@helpers/templates-listing";

import { CUSTOMER_CASE_STUDIES_SLUG, DEFAULT_TEMPLATES_PAGE_ROUTE } from "@constants/routes";
import {
  ALL_TEMPLATE_SLUG,
  DEFAULT_TEMPLATES_CATEGORY_DESCRIPTION,
  DEFAULT_CATERGORY_SLUG,
  RECOMMENDED_TEMPLATES_SLUG,
  DEFAULT_TEMPLATE_CATEGORY_TEXT,
} from "@constants/templates-listing";
import { SHOP_LISTING } from "@constants/june-so";

import styles from "./purge-main.module.scss";

const emptyObj = {};

const AllTemplatesPageContainer = ({
  defaultCategoryDescription = "",
  defaultPageRoute = DEFAULT_TEMPLATES_PAGE_ROUTE,
  defaultCategoryText = DEFAULT_TEMPLATE_CATEGORY_TEXT,
  defaultCategoryTitle = "",
  tagsVisibility: { showAccountShops = true, showCustomerCaseStudies = true } = emptyObj,
} = emptyObj) => {
  const pageName = usePageNameContext();
  const router = useRouter();
  const { query: { templateSlug } = emptyObj, push, replace } = router;

  const [isGridView, setIsGridView] = useState(true);
  const [currentCategory, setCurrentCategory] = useState(() => ({
    name: getCapitalisedSlug(DEFAULT_CATERGORY_SLUG),
    id: "",
  }));
  const {
    modifiedMarketingCategories,
    loadingMarketingCategories,
    loadingAccountShops,
    accountShops,
    mappedAccountShops,
    modifiedAccountsForSlug,
    initialCategoryPayload,
  } = useFetchMarketingCategories({
    currentCategory: currentCategory?.name,
    templateSlug,
    showAccountShops,
  });
  if (!showCustomerCaseStudies) {
    remove(modifiedMarketingCategories, ({ slug }) => slug === CUSTOMER_CASE_STUDIES_SLUG);
  }

  const templateSelectHandler = (templateUrl) => {
    push(templateUrl);
  };

  const {
    name: initialCategoryName,
    slug: initialCategorySlug,
    description: categoryDescription,
  } = initialCategoryPayload || emptyObj;

  useEffect(() => {
    if (!loadingMarketingCategories && !loadingAccountShops) {
      if (
        templateSlug?.[0] !== ALL_TEMPLATE_SLUG &&
        !initialCategoryName &&
        templateSlug?.[0] !== initialCategorySlug
      ) {
        replace(defaultPageRoute);
      } else setCurrentCategory({ ...currentCategory, name: initialCategoryName });
    }
  }, [
    loadingMarketingCategories,
    initialCategoryName,
    initialCategorySlug,
    loadingAccountShops,
    templateSlug,
    defaultPageRoute,
  ]);

  const shouldRenderRecommendedTemplate = RECOMMENDED_TEMPLATES_SLUG.includes(templateSlug?.[0]);
  const recommendedShopId = modifiedAccountsForSlug?.[0]?.id;
  const recommendedShop = mappedAccountShops[recommendedShopId]?.[0] || emptyObj;

  const categoryTitle = defaultCategoryTitle || getCategoryTitle(currentCategory?.name);

  return (
    <section className={styles.container} area-labeledby="title" tabIndex={0}>
      <h1 className={styles.pageContentTitle} id="title">{categoryTitle}</h1>
      <h2 className={styles.pageContentDescription}>
        {defaultCategoryDescription ||
          categoryDescription ||
          DEFAULT_TEMPLATES_CATEGORY_DESCRIPTION}
      </h2>
      <InstantSearchWrapper>
        <div className={styles.pageContentContainer}>
          <div className={styles.templateSectionTitleMobile}>
            {currentCategory?.name || defaultCategoryText}
          </div>
          <div className={styles.categoriesSideBar}>
            <div className={styles.categoriesSideBarHolder}>
              <SearchInput onTemplateSelect={templateSelectHandler} />
              <CategoriesSection
                marketingCategories={modifiedMarketingCategories}
                setCurrentCategory={setCurrentCategory}
                currentCategory={currentCategory}
                onTemplateSelect={templateSelectHandler}
              />
            </div>
          </div>
          <section className={styles.templatesSection}>
            <div className={styles.templateSectionHeader}>
              <AllTemplatesHeader
                isGridView={isGridView}
                setIsGridView={setIsGridView}
                onTemplateSelect={templateSelectHandler}
                currentCategory={currentCategory}
              />
            </div>
            <div className={styles.templatesContainer}>
              {shouldRenderRecommendedTemplate && !isEmpty(recommendedShop) && (
                <RecommendedTemplate
                  {...recommendedShop}
                  recommendedAccount={modifiedAccountsForSlug?.[0]}
                  onTemplateSelect={templateSelectHandler}
                  loadingAccountShops={loadingAccountShops}
                  pageName={pageName || SHOP_LISTING}
                />
              )}
              {accountShops ? (
                <AccountShops
                  shops={accountShops}
                  isGridView={isGridView}
                  onTemplateSelect={templateSelectHandler}
                  pageName={pageName || SHOP_LISTING}
                />
              ) : (
                <TemplateViews
                  isGridView={isGridView}
                  onTemplateSelect={templateSelectHandler}
                  pageName={pageName || SHOP_LISTING}
                />
              )}
            </div>
          </section>
        </div>
      </InstantSearchWrapper>
    </section>
  );
};

export default AllTemplatesPageContainer;
